export const phoneNum = {
  label: "(855) 738-1940",
  value: "+1-855-738-1940",
};
